<template lang="pug">
div.container
  div.body
    div
      img.back-button( src="@/assets/ic-left.svg" @click="recoverPass()")
      div.logo
        img( src="@/assets/kiddiecoinLogo.svg")
      div.header
        span.text-23-b Восстановление пароля
      div.password-text.text-16
        div.mb-2 Если вы забыли пароль, восстановить его онлайн невозможно.
        div.mb-2 Восстановление доступа осуществляется при личном обращении в офис вприсутствии родителя (законного представителя) и при предъявлении документов.
        div.mb-2 Сотрудник офиса проверит данные и поможет установить новый пароль.
        div.mb-2 Удалённое восстановление пароля не предусмотрено в целях безопасности.
        div.mb-2 По вопросам восстановления доступа обратитесь к сотруднику офиса.
</template>

<script>
export default{
  name:"RememberPassword",

  methods: {
    recoverPass() {
      window.location.href = "#logout"
    }
  }
}
</script>

<style scoped>
.container {
  width: 100%;
  height: 100%;
}
.body {
  width: auto;
  height: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 40px 16px 0px 16px;
}
.logo {
  margin: 0px 0px 10px 0px;
}
.header {
  text-align: center;
  margin: 30px 0;
}
.password-text {
  text-align: start;
}
.back-button {
  display: flex;
}
</style>